import { CensoService } from '@app/shared/services/censo.service';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { environment } from '@environments/environment';

import { AuthenticationService } from '@app/shared/services';
import { MessagingService } from '@app/shared/services/messaging.service';
import { UtilService } from './../../shared/services/util.service';
import { MensagemService } from '@app/shared/services/mensagem.service';

import { LoginUsuario, Loading, Censo } from '@app/shared/models';

@Component({
  selector: 'app-acesso-interno',
  templateUrl: './acesso-interno.component.html',
  styleUrls: ['./acesso-interno.component.scss']
})
export class AcessoInternoComponent implements OnInit {

  carregar = new Loading();
  cliente = environment.cliente;
  formLogin: FormGroup = new FormGroup({});
  censo: Censo;

  constructor(
    private router: Router,
    private formBuilder: FormBuilder,
    private auth: AuthenticationService,
    private messagingService: MessagingService,
    private activatedRoute: ActivatedRoute,
    private mensagemService: MensagemService,
    private utilService: UtilService,
    private censoService: CensoService
  ) {
    this.censo = this.censoService.retornarSessionStorage('censo');

    this.activatedRoute.queryParamMap.subscribe((params: any) => {
      if (this.cliente.chave_interna == null || params.params.chave != this.cliente.chave_interna) {
        this.router.navigate(['/']);
      }
    });
  }

  ngOnInit(): void {
    this.formLogin = this.formBuilder.group({
      nome: [null, Validators.required],
      cpf: [null, Validators.required],
      dataNascimento: [null, Validators.required],
      nomeMae: [''],
      siafi: this.cliente.siafi,
      idCenso: this.cliente.censo_id,
      tokenFirebase: this.messagingService.getCurrentToken(),
      chaveInterna: this.cliente.chave_interna
    });
  }

  submitForm(): void {
    this.formLogin = this.utilService.verificarForm(this.formLogin);

    if (this.formLogin.invalid) return this.mensagemService.avisoFormularioInvalido();

    const dataNascimento = this.utilService.formatarDataPadraoHTML(this.formLogin.get('dataNascimento')?.value);

    const loginUsuario: LoginUsuario = {
      ...this.formLogin.value,
      dataNascimento: dataNascimento,
      nome: (this.formLogin.get('nome')?.value).toUpperCase(),
      nomeMae: (this.formLogin.get('nomeMae')?.value).toUpperCase()
    }

    this.auth.login(loginUsuario, this.carregar).subscribe(() => {
      this.router.navigate(['/recadastramento/primeiro-passo/']);
    });
  }
}
